import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import iconXsair from "../imagem/iconXsair.png";

function DesejaSair({ abrirModal, sair, fechar }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openModalConf, setOpenModalConf] = useState(false);

  return (
    <>
      {abrirModal && (
        <div>
          <Modal
            open={abrirModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "var(--cor-branco)",
                boxShadow: 24,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 4,
                width: "90%",
                maxWidth: 360,
                height: "auto",
                opacity: 1,
                borderRadius: "24px",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 4}}>
                <img
                  src={iconXsair}
                  onClick={fechar}
                  style={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem",
                    cursor: "pointer",
                  }}
                />
                <Typography
                  variant="h6"
                  component="h2"
                  onClick={sair}
                  sx={{
                    textAlign: "center",
                    color: "var(--cor-preto)",
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    lineHeight: "100%",
                  }}
                >
                  Deseja sair?
                </Typography>

                <Box sx={{ display: "flex", gap: "1.5rem", width: "100%" }}>
                  <Button
                    sx={{
                      flex: 1,
                      minWidth: "10.0rem",
                      maxWidth: "12.5rem",
                      height: "2.8rem",
                      bgcolor: "var(--cor-branco)",
                      color: "var(--cor-roxoEscuro)",
                      border: "1px solid var(--cor-roxoEscuro)",
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: 700,
                      fontSize: "1.0rem",
                    }}
                    onClick={fechar}
                  >
                    Cancelar
                  </Button>

                  <Button
                    onClick={sair}
                    sx={{
                      flex: 1,
                      minWidth: "10.0rem",
                      maxWidth: "12.5rem",
                      height: "2.8rem",
                      bgcolor: "var(--cor-roxoEscuro)",
                      color: "white",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "1.0rem",
                    }}
                  >
                    Sair
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
}

export default DesejaSair;
